import React from 'react';

import { PageHeader } from '@vlabs/monokit/shared/ui/page';
import { Breadcrumb, Breadcrumbs } from '@vlabs/uikit';
import { generatePath } from 'react-router-dom';

import { routes } from '@vlapps/point3/src/app/routes';

import { useEventDetailsPageTranslation } from '../i18n';

function EventDetailsPageHeader(): React.JSX.Element {
  const { t } = useEventDetailsPageTranslation();

  return (
    <PageHeader
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('archive')}
            href={generatePath(routes.events.archive)}
          />
          <Breadcrumb caption={t('title')} />
        </Breadcrumbs>
      )}
      title={t('title')}
    />
  );
}

export { EventDetailsPageHeader };
